import React, { useRef } from 'react'
import { Swiper } from 'swiper/react'
import { Autoplay, EffectFade } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-fade'
import { ReactComponent as Arrow } from '../../assets/sliderArrow.svg'
import style from './style.module.scss'
import { useMediaQuery } from '../../hooks'

export const CommonHero: React.FC<React.PropsWithChildren> = ({ children }) => {
    const swiperRef = useRef<any>(null)

    const isTablet = useMediaQuery('(max-width: ' + style.tabletBreakpoint + ')')

    const swiperProps = {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: { delay: 60000000, disableOnInteraction: true },
        shortSwipes: isTablet ? true : false,
        touchRatio: isTablet ? 1 : 0,
        loop: true,
        modules: [Autoplay, EffectFade],
    }

    const swipe = (next: number) => {
        if (next === 1) swiperRef?.current?.swiper.slideNext(400)
        else swiperRef?.current?.swiper.slidePrev(400)
    }

    if (!React.Children.count(children)) {
        return null
    }

    return (
        <div className={style.block}>
            <Swiper ref={swiperRef} {...swiperProps} className={style.swiper} effect={'fade'}>
                {children}
            </Swiper>

            <div className={style.nav}>
                <div className={style.prev} onClick={() => swipe(-1)}>
                    <Arrow />
                </div>
                <div className={style.next} onClick={() => swipe(1)}>
                    <Arrow />
                </div>
            </div>
        </div>
    )
}
